// **React Imports
import { Suspense, useMemo } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

// **Component Imports
import OverlayLoading from '../components/overlay-loading'
import ErrorBoundary from '../pages/error'

// **Utils Imports
import { ROLES } from '../utils/constant'
import { getJWTToken, getUserDetails } from '../utils/utils'

const RestrictedRoute = () => {
  //variables
  const jwt = useMemo(() => getJWTToken(), [])
  const userDetails = useMemo(() => getUserDetails(), [])

  if (jwt && userDetails) {
    if (userDetails?.roles?.toLowerCase() === ROLES.CANDIDATE) {
      return <Navigate to="/c" replace />
    } else {
      return <Navigate to="/" replace />
    }
  } else {
    return (
      <ErrorBoundary>
        <Suspense fallback={<OverlayLoading />}>
          <Outlet />
        </Suspense>
      </ErrorBoundary>
    )
  }
}

export default RestrictedRoute
